import axios from "axios";
import { createContext, useEffect, useState } from "react";
import { useOktaConfig } from "./CredentialsContext";
import { useNavigate } from "react-router-dom";

export const MarktingContext = createContext(null);


export default function MarktingProvider({ children }) {
  const { loginToken } = useOktaConfig();

  const [marktingData, setMarktingData] = useState([]);
  const [archivedData, setArchivedData] = useState([]);
  const [userTeam, setUserTeam] = useState([]);
  const navigation = useNavigate();



  // marketing data
  const fetchMarktingData = async () => {
    try {
      const [marketingData, archivedData] = await Promise.all([
        axios.get(`${process.env.REACT_APP_API_URL}/marketing`, {
          headers: {
            Authorization: `Bearer ${loginToken}`,
          },
        }),
        axios.get(`${process.env.REACT_APP_API_URL}/marketing?archived=true`, {
          headers: {
            Authorization: `Bearer ${loginToken}`,
          },
        }),
      ]);
      const data = {
        marketingData: marketingData.data.data,
        archivedData: archivedData.data.data,
      };


      setMarktingData(data.marketingData);
      setArchivedData(data.archivedData);
    } catch (error) {
      if (error?.response?.status === 401) {
        localStorage.removeItem("Firebase Auth");
        localStorage.removeItem("okta-token-storage");
        localStorage.removeItem("okta-cache-storage");
        navigation('/');
        // console.error("seassion expired");
        return;
      };
      // console.error("Error fetching data:", error);
    }
  };

  // The empty array ensures the effect runs only once after the component mounts
  useEffect(() => {
    if (loginToken) {
      const team = sessionStorage.getItem("Team");
      if (team) {
        setUserTeam(team);
      }
      fetchMarktingData();
    }
  }, [loginToken]); // Empty dependency array ensures this runs once

  // public url (expire in 1 hour)
  async function fetchPublicUrl(id) {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_URL}/content/url/${id}`,
        {
          headers: {
            Authorization: `Bearer ${loginToken}`,
          },
        }
      );
      return data.fileContent;
    } catch (error) {
      if (error?.response?.status === 401) {
        localStorage.removeItem("Firebase Auth");
        localStorage.removeItem("okta-token-storage");
        localStorage.removeItem("okta-cache-storage");
        navigation('/');
        // console.error("session expired");
        return;
      };
      // console.error('Error fetching content:', error);
      return null;
    }
  }

  const fetchDataById = async (id) => {
    
    try {
      const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/marketing/${id}`, {
        headers: {
          Authorization: `Bearer ${loginToken}`,
        },
      });
      return data;
    } catch (error) {
      if (error?.response?.status === 401) {
        localStorage.removeItem("Firebase Auth");
        localStorage.removeItem("okta-token-storage");
        localStorage.removeItem("okta-cache-storage");
        navigation('/');
        // console.error("session expired");
        return;
      };
      // console.error('Error fetching content:', error);
      return null;
    }
  };
  const reviewData = async (id) => {
    try {
      const { data } = await axios.put(
        `${process.env.REACT_APP_API_URL}/marketing/review/${id}`,
        {},                                 // 2) data (empty body)
        {                                   // 3) config
          headers: {
            Authorization: `Bearer ${loginToken}`
          }
        }
      );

      return data;
    } catch (error) {
      // console.log(error?.response);


      if (error?.response?.status === 401) {
        localStorage.removeItem("Firebase Auth");
        localStorage.removeItem("okta-token-storage");
        localStorage.removeItem("okta-cache-storage");
        navigation('/');
        // console.error("session expired");
        return;
      };
      // console.error('Error fetching content:', error);
      return null;
    }
  };

  return (
    <MarktingContext.Provider value={{ marktingData, archivedData, setMarktingData, setArchivedData, fetchPublicUrl, fetchDataById, userTeam, setUserTeam, reviewData }}>
      {children}
    </MarktingContext.Provider>
  );
}
